import { AppShell } from './AppShell';

export function LabConsoleShell() {
  return <AppShell defaultTheme="light" />;
}
